<template>
  <div class="guidesDoc">
    <div class="doc-nav">
      <div class="header-left">
        <div class="menu-item">
          <div>
            <router-link style="margin-left: 0;" :to="gotoMain()">{{menu.lev1}}</router-link>>
            <router-link :to="gotoMain()">{{menu.lev2}}</router-link>
          </div>
        </div>
      </div>
      <div class="header-right">
        <a v-if="!$root.$data.wiseStack && docInfo && docInfo.docType==='PDF'"
           :href="getPdfHref(docInfo.link)" title="Download PDF"
           class="header-right-button download">
          <i class="icon-download"></i>
          <span>PDF</span>
        </a>
        <!-- <a v-if="docInfo.docType!='PDF'" @click="getAllPdf()" title="Download PDF"
           class="header-right-button download">
           <i class="icon-download"></i>
           <span>PDF</span>
        </a>  -->
        <div class="header-right-button feedback" @click="gotoFeedback" v-if="!this.$root.$data.wiseStack">
          <i class="icon-feedback"></i>
          <span>{{$t("Feedback")}}</span>
        </div>
        <div class="header-right-button share" @click="shareLink" v-if="!this.$root.$data.wiseStack">
          <i class="icon-share"></i>
          <span>{{$t("Share")}}</span>
        </div>
        <div class="header-right-button mb-closesideMenu" @click="toggleSideMenu">
          <i class="icon-sideMenu"></i>
        </div>
      </div>
    </div>
    <div class="doc-warning-dialog" v-if="noDocWarningShow">
      <div>
        <i class="icon-warning"></i>
        <span>{{$t("not_available_in_your_lang") + $t(docInfo.lang) + $t("is_lang_version")}}</span>
      </div>
      <el-button
        icon='tp-icon-close'
        type="icon"
        size="small"
        @click="noDocWarningShow=false"/>
    </div>
    <div class="mainContent" :class="{mainContent_stack:this.$root.$data.wiseStack}">
      <aside class="sideMenuWrap scroll" v-show="sideMenuOpen">
        <div class="sideMenu scroll">
          <div class="menuLevl3">{{menu.lev3}}</div>
          <!-- 左側菜單 -->
          <el-tree
            :data="menu.lev4"
            :props="defaultProps"
            :default-expanded-keys="expandedKeys"
            :current-node-key="currentNodeKey"
            class="sideMenuNode"
            node-key="id"
            ref="tree"
            @node-click="handleNodeClick">
            <span slot-scope="{ node, data }" class="el-tree-node__label">
              <span>{{ node.label }}<i v-if="data.docType==='VIDEO'"></i></span>
            </span>
          </el-tree>
        </div>
      </aside>
      <div class="closesideMenu" @click="toggleSideMenu" :class="{sideMenuClose:!sideMenuOpen}">
        <el-tooltip placement="bottom-start" effect="light">
          <div slot="content" style="padding:0 6px 0 6px;line-height:16px;">{{$t("split_bar")}}</div>
          <i class="drag"></i>
        </el-tooltip>
      </div>
      <div class="mdFile" :class="{'mdFile-mb-hide':sideMenuOpen}" >
        <guides-doc-content ref="child" v-if="activeDoc" :doc-info="docInfo" :video-info="videoInfo"></guides-doc-content>
      </div>
    </div>
    <el-dialog
      class="td-share-dialog"
      :title="$t('Share')"
      :visible.sync="isShareDialogVisible"
      width="400px"
      :append-to-body="true"
      @open="openShareDialog"
      >
      <div class="share-title">
        <i class="td-icon-mail"></i>
        <a :href="'mailto:?subject=Technical Documentation;body=' + getCurrentDocUrl()">
          <span>{{$t("Email")}}</span>
        </a>
      </div>
      <div class="share-title">
        <i class="td-icon-duplicate"></i>
        <span @click="copyDocUrl">{{$t("Copy_link")}}</span>
        <i class="td-icon-confirm" v-if="isShareLinkCopied"></i>
      </div>
    </el-dialog>
    <el-dialog
      :title="oauthDialog.title"
      custom-class="tp-downloadallpdf-loading-dialog"
      :visible.sync="oauthDialogVisible"
      :append-to-body="true"
      :show-close="false"
      :closeOnClickModal="false"
      width="420px">
      <div class="tp-icon-loading" v-if="oauthDialog.status==1"></div>
      <div class="context" v-if="oauthDialog.status==1">Download PDF File...Please Wait!</div>
      <div class="context" v-if="oauthDialog.status==2">
        Please contact to <span style="color: #008cd6;text-decoration: underline;">wise-paas.training@advantech.com.tw</span>
      </div>
      <div slot="footer" class="dialog-footer" v-if="oauthDialog.status==2">
        <el-button @click="oauthDialogVisible=false">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import guidesDocContent from '@/components/GuidesDoc/GuidesDocContent.vue'
import frontAPI from '@/api/frontstage/frontAPI'
import docAPI from '@/api/backstage/doc'

export default {
  name: 'guidesDoc',
  metaInfo () {
    let links = []
    links.push({
      rel: 'canonical',
      href: window.location.origin + window.location.pathname
    })
    let langOptions = this.$store.state.langOptions
    let pathSubstring = this.$route.path.substring(this.$route.params.lang.length + 1)
    for (let lang of langOptions) {
      links.push({
        rel: 'alternate',
        hreflang: lang.langKey,
        href: window.location.origin + '/' + lang.langKey + pathSubstring
      })
    }
    return {
      title: this.htmlTitle,
      link: links
    }
  },
  data () {
    return {
      htmlTitle: '',
      oldLang: 1,
      footerVisibleHeight: 0,
      activeDoc: false,
      noDocWarningShow: false,
      sideMenuOpen: true,
      replaceLang: '',
      currentNodeKey: '',
      lastWindowInnerWidth: '',
      docInfo: {},
      videoInfo: {
        sources: [],
        refs: []
      },
      expandedKeys: [],
      menu: {
        lang: 1,
        lev1: '',
        lev2: '',
        lev3: '',
        lev4: [],
        menuName: ''
      },
      defaultProps: {
        label: 'title',
        children: 'children',
        docType: 'docType'
      },
      isShareDialogVisible: false,
      isShareLinkCopied: false,
      oauthDialogVisible: false,
      oauthDialog: {
        title: '',
        status: 1
      }
    }
  },
  components: {
    guidesDocContent
  },
  created () {
    this.sideMenuOpen = window.innerWidth > 635
    this.switchLang()
    this.renderMenu()
    this.renderPath()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.windowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
  },
  watch: {
    $route (to, from) {
      if (this.$i18n.locale === this.oldLang) {
        this.renderDoc()
      } else {
        this.switchLang()
        this.replaceLang = ''
        this.noDocWarningShow = false
        this.renderPath()
        this.renderMenu()
      }
    }
  },
  methods: {
    switchLang () {
      this.menu.lang = this.$store.getters.getLangByKey(this.$i18n.locale).langId
      this.oldLang = this.$i18n.locale
    },
    renderPath () {
      frontAPI
        .queryMenuByNameAndLang(
          '?menu_name=' +
          this.$route.params.menuLevel1 +
          '&lang=' +
          this.menu.lang +
          '&layer_num=1'
        )
        .then(resp => {
          this.menu.lev1 = resp.data.data.title
        })
        .catch(err => {
          this.$router.push({ name: 'frontNotFound' })
          console.log('queryMenu error---', err)
        })
      frontAPI
        .queryMenuByNameAndLang(
          '?menu_name=' +
            this.$route.params.menuLevel2 +
            '&lang=' +
            this.menu.lang +
            '&layer_num=1'
        )
        .then(resp => {
          this.menu.lev2 = resp.data.data.title
        })
        .catch(err => {
          this.$router.push({ name: 'frontNotFound' })
          console.log('queryMenu error---', err)
        })
    },
    renderMenu () {
      // 讀取左側 menu
      let datasort = []
      const datasortFinal = []
      frontAPI
        .queryMenuByNameAndLang(
          '?menu_name=' +
            this.$route.params.menuLevel3 +
            '&lang=' +
            this.menu.lang +
            '&layer_num=2'
        )
        .then(resp => {
          var data = resp.data
          if (data.data) {
            this.menu.menuName = data.data.menu_name
            this.menu.lev3 = data.data.title
            if (data.data.children) {
              datasort = data.data.children
              // menu.children (doc only 第5層) 依 order 排序
              for (let i = 0; i < datasort.length; i++) {
                const element = datasort[i]
                if (element.children) {
                  element.children.sort(function (a, b) {
                    return a.order - b.order
                  })
                }
              }
              // menu & doc(第4層) 依 order 排序
              datasort.sort(function (a, b) {
                return a.order - b.order
              })
              // 剔除沒有文章的 menulev4 目錄
              for (let i = 0; i < datasort.length; i++) {
                const element = datasort[i]
                if ((element.type === 'menu' && element.children) || element.type === 'doc') {
                  if (element.type === 'doc') {
                    element.level = 4
                  }
                  datasortFinal.push(element)
                }
              }
              this.menu.lev4 = datasortFinal
            } else {
              this.menu.lev4 = []
            }
          } else {
            this.$router.push({ name: 'frontNotFound' })
          }
        })
        .catch(err => {
          console.log('queryMenu error---', err)
          this.$router.push({ name: 'frontNotFound' })
        })
        .then(() => {
          if (this.$route.params.doc_name) {
            this.renderDoc()
          } else {
            if (this.menu.lev4) {
              this.assignDocName()
            }
          }
        })
    },
    renderDoc () {
      this.activeDoc = false
      let ver = this.$route.params.ver
      let docName = this.$route.params.doc_name
      let lang = ''
      if (this.replaceLang) {
        lang = this.replaceLang
        this.docInfo.lang = this.replaceLang
      } else {
        lang = this.menu.lang
        this.docInfo.lang = this.menu.lang
      }
      if (window.location.hostname == this.$store.state.hostNameVals.chainHostName)
      {
        if(ver == undefined)
        {
          docAPI
            .getDocId('docName=' + docName + '&lang=' + lang)
            .then(resp => {
              frontAPI
                .queryVersion('?doc_id=' + resp.data.id)
                .then(resp => {
                  if (resp.data.data) {
                    let verlist = resp.data.data
                    verlist = verlist.sort(function (a, b) {
                      return a.version > b.version ? -1 : 1
                    })

                    ver = verlist[0].version

                    this.renderDocFun(docName, lang, ver)
                  }
                })
            })
        }
        else
        {
          this.renderDocFun(docName, lang, ver)
        }
      }
      else
      {
        this.renderDocFun(docName, lang, ver)
      }
    },
    assignDocName () {
      let docList = this.menu.lev4
      if (docList[0].docType === 'M.D.' || docList[0].docType === 'PDF' || docList[0].docType === 'API' || docList[0].docType === 'VIDEO') {
        this.$router.replace({
          params: {
            doc_name: docList[0].file_name,
            ver: docList[0].version
          }
        })
      } else {
        this.$router.replace({
          params: {
            doc_name: docList[0].children[0].file_name,
            ver: docList[0].children[0].version
          }
        })
      }
    },
    searchReplaceDoc () {
      let docName = this.$route.params.doc_name
      docAPI
        .getDocId(
          'docName=' + docName +
          '&lang=' + this.menu.lang
        )
        .then(resp => {
          frontAPI
            .queryVersion('?doc_id=' + resp.data.id)
            .then(resp => {
              if (resp.data.data) {
                let verlist = resp.data.data
                if (verlist[verlist.length - 1].version !== this.$route.params.ver) {
                  this.$router.replace({
                    params: {
                      ver: verlist[verlist.length - 1].version
                    }
                  })
                }
              } else {
                this.searchReplaceDocLang()
              }
            })
            .catch(err => {
              console.log('queryVersion error---', err)
            })
        })
        .catch(err => {
          console.log('getDocId error---', err)
        })
    },
    searchReplaceDocLang () {
      let lang = 1
      this.searchLang(lang)
    },
    searchLang (lang) {
      let docName = this.$route.params.doc_name
      docAPI
        .getDocId(
          'docName=' + docName +
          '&lang=' + lang
        )
        .then(resp => {
          frontAPI
            .queryVersion('?doc_id=' + resp.data.id)
            .then(resp => {
              if (resp.data.data) {
                let verlist = resp.data.data
                let verlistsort = verlist.sort(function (a, b) {
                    return a.version > b.version ? 1 : -1
                })
                this.replaceLang = lang
                this.noDocWarningShow = true
                if (verlistsort[verlistsort.length - 1].version !== this.$route.params.ver) {
                  this.$router.replace({
                    params: {
                      ver: verlistsort[verlistsort.length - 1].version
                    }
                  })
                } else {
                  this.renderDoc()
                }
              } else {
                lang += 1
                if (lang == 2) { //跳過簡中
                  lang += 1
                }
                if (lang <= 4) {
                  this.searchLang(lang)
                } else {
                  this.$router.push({ name: 'frontNotFound' })
                }
              }
            })
            .catch(err => {
              console.log('queryVersion error---', err)
            })
        })
        .catch(err => {
          console.log('getDocId error---', err)
        })
    },
    handleNodeClick (data) {
      this.replaceLang = ''
      this.noDocWarningShow = false
      if (!data.level) {
        this.expandedKeys = [data.menu_id]
      }
      if (data.docType === 'M.D.' || data.docType === 'PDF' || data.docType === 'API' || data.docType === 'VIDEO') {
        if (window.innerWidth <= 635) {
          this.sideMenuOpen = false
        }
        this.$router.replace({
          params: {
            doc_name: data.file_name.trim(),
            ver: data.version.trim()
          }
        })

        if(window.location.hostname == this.$store.state.hostNameVals.chainHostName)
        {
          var url = window.location.pathname.split('/')
          var urlVerPath = url[url.length - 1]
          var newparams = '';

          if (urlVerPath.indexOf('v') === 0) {
            for(var i=0; i<url.length-1; i++)
            {
              if(i == 0)
              {
                newparams += url[i]
              }
              else
              {
                newparams += '/' + url[i]
              }
            }

            window.location.pathname = newparams

          }      
        }
      }
    },
    toggleSideMenu () {
      this.sideMenuOpen = !this.sideMenuOpen
      if (window.innerWidth > 635) {
        this.$refs.child.sideMenuOpen = this.sideMenuOpen
      }
    },
    windowResize () {
      if (window.innerWidth <= 635 && this.lastWindowInnerWidth > 635 && this.sideMenuOpen) {
        this.sideMenuOpen = false
        this.$refs.child.sideMenuOpen = false
      } else if (window.innerWidth > 635 && this.lastWindowInnerWidth <= 635 && !this.sideMenuOpen) {
        this.sideMenuOpen = true
        this.$refs.child.sideMenuOpen = true
      }
      this.lastWindowInnerWidth = window.innerWidth
    },
    handleScroll () {
      let windowVisibleHeight = window.innerHeight
      let windowScrollHeight = document.documentElement.scrollHeight
      let scrollHeight = window.pageYOffset
      let tmp = 50 - (windowScrollHeight - windowVisibleHeight - scrollHeight)
      if (tmp < 0) {
        this.footerVisibleHeight = 0
      } else {
        this.footerVisibleHeight = tmp
      }
    },
    getPdfHref (url) {
      return window.location.origin + url
    },
    gotoFeedback () {
      this.$refs.child.clickMenu('feedbackBlock')
    },
    openShareDialog () {
      this.isShareLinkCopied = false
    },
    shareLink () {
      if (window.navigator.share) {
        window.navigator.share({
          title: 'Technical Documentation',
          text: 'Technical Documentation | WISE-PaaS | Advantech',
          url: window.location.href
        })
          .then(() => console.log('navigation share success!'))
          .catch((error) => console.log('navigation share error!', error))
      } else {
        this.isShareDialogVisible = true
      }
    },
    getCurrentDocUrl () {
      return window.location.href
    },
    copyDocUrl () {
      let that = this
      this.$copyText(this.getCurrentDocUrl()).then(function (e) {
        that.isShareLinkCopied = true
      }, function (e) {
      })
    },
    gotoMain () {
      var nameRouter = {}
      switch(this.$route.params.menuLevel1) {
        case "Guides_and_API_References":
          nameRouter = { name: 'main' }
          break;
        case "1593419570561601510":                    // WISE-iFactory
          nameRouter = { name: 'main-wiseifactory'}
          break;
        case "1593482576149865662":                    // WISE-iService
          nameRouter = { name: 'main-wiseiservice'}
          break;
        case "1664174110532910960":                    // WISE-iMachine
          nameRouter = { name: 'main-wiseimachine'}    
          break;
        case "1664174297776957277":                    // WISE-iEMS
          nameRouter = { name: 'main-wiseiems'}
          break;
      }

      return nameRouter

      // return this.$route.params.menuLevel1 === 'Guides_and_API_References' ? { name: 'main' } : { name: 'main-wiseifactory' }
    },
    changeHtmlTitle (title) {
      document.title = title + ' | Technical Documentation | Advantech'
      this.htmlTitle = title + ' | Technical Documentation | Advantech'
    },
    renderDocFun(docName, lang, ver){
      frontAPI
        .queryDocumentByNameAndVersionAndLang('?file_name=' + docName + '&lang=' + lang + '&version=' + ver)
        .then(resp => {
          let data = resp.data
          if (!data.data) {
            this.searchReplaceDoc()
          } else {
            let docInfo = data.data[0]
            this.docInfo.version = ver
            this.docInfo.docName = docName
            this.docInfo.id = docInfo.id
            this.docInfo.docTitle = docInfo.title
            this.changeHtmlTitle(docInfo.title + ' | ' + this.menu.lev3)
            this.docInfo.log_id = docInfo.log_id
            this.docInfo.content = docInfo.content
            this.docInfo.forumId = this.menu.menuName
            this.docInfo.time = docInfo.log_update_time
            this.docInfo.docType = docInfo.docType
            this.docInfo.link = docInfo.doc_type
            this.docInfo.sideMenuOpen = this.sideMenuOpen
            if (docInfo.docType === 'VIDEO' && docInfo.content) {
              let videoContent = docInfo.content
              this.docInfo.content = videoContent.substring(videoContent.indexOf('<TDMD>') + 6, videoContent.indexOf('</TDMD>'))
              this.videoInfo.refs = JSON.parse(videoContent.substring(videoContent.indexOf('<TDVideoRefs>') + 13, videoContent.indexOf('</TDVideoRefs>')))
              this.videoInfo.sources = []
              let sources = JSON.parse(videoContent.substring(videoContent.indexOf('<TDVideoSources>') + 16, videoContent.indexOf('</TDVideoSources>')))
              for (let i = 0; i < sources.length; i++) {
                const source = sources[i]
                if (source.link.endsWith('.swf')) {
                  source.type = 'embed'
                } else {
                  source.type = 'iframe'
                }
                this.videoInfo.sources.push(source)
              }
            }
            this.activeDoc = true
            if (this.replaceLang) {
              let docName = this.$route.params.doc_name
              docAPI
                .getDocId('docName=' + docName + '&lang=' + this.menu.lang)
                .then(resp => {
                  this.expandedKeys = [resp.data.id]
                  this.currentNodeKey = resp.data.id
                  this.$refs.tree.setCurrentKey(this.currentNodeKey)
                })
            } else {
              this.expandedKeys = [docInfo.id]
              this.currentNodeKey = docInfo.id
              this.$refs.tree.setCurrentKey(this.currentNodeKey)
            }
          }
        })
        .catch(err => {
          console.log('queryDocumentByNameAndVersionAndLang error---', err)
        })
    },
    getAllPdf(){
      this.oauthDialog.status = 1
      this.oauthDialog.title = ''
      this.oauthDialogVisible = true
      let docName = this.$route.params.menuLevel3
      let lang = this.docInfo.lang
      let url = '?menuName=' + docName + '&lang=' + lang
      frontAPI
        .downloadAllProductPDF(url)
        .then(resp => {
          if(resp.data.status == "fail")
          {
            this.oauthDialogVisible = false
            this.oauthDialog.status = 2
            this.oauthDialog.title = 'Download Filed'
            this.oauthDialogVisible = true

          }else
          {
            this.oauthDialogVisible = false
            window.location.href = resp.config.url
          }
        })
        .catch(resp => {
          this.oauthDialogVisible = false
          this.oauthDialog.status = 2
          this.oauthDialog.title = 'Download Filed'
          this.oauthDialogVisible = true
        })
    }
  }
}
</script>

<style lang="scss">
.no-header {
  .guidesDoc {
    .mainContent{
      .sideMenuWrap, .closesideMenu {
        max-height: calc(100vh - 106px);
      }
      @media (max-width: 950px) {
        .sideMenuWrap, .closesideMenu  {
          max-height: calc(100vh - 98px) !important;
        }
      }
      @media (max-width: 635px) {
        .sideMenuWrap {
          max-height: none !important;
        }
      }
    }
  }
  &.no-footer {
    .guidesDoc {
      .mainContent{
        .sideMenuWrap, .closesideMenu {
          max-height: calc(100vh - 56px);
        }
        @media (max-width: 950px) {
          .sideMenuWrap, .closesideMenu  {
            max-height: calc(100vh - 48px) !important;
          }
        }
        @media (max-width: 635px) {
          .sideMenuWrap {
            max-height: none !important;
          }
        }
      }
    }
  }
}
.mainContent{
  .sideMenuWrap{
    overflow-x: hidden;
    display: block;
    position: sticky;
    top: 56px;
    max-height: calc(100vh - 184px);
  }
  .closesideMenu {
    position: sticky;
    top: 56px;
    min-height: calc(100vh - 234px);
    max-height: calc(100vh - 184px);
  }
}
.sideMenu > .el-tree {
  margin-bottom: 16px;
}
.el-tree__empty-block > .el-tree__empty-text {
  display: none;
}
.scroll::-webkit-scrollbar {
  width: 10px;
}
.scroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 12px;
}
.scroll:hover::-webkit-scrollbar-thumb {
  background: #c8c8c8;
}
.scroll {
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}

.sideMenuNode{
  .el-tree-node__label{
    i {
      background-image: url('../../assets/icon/btn_main_video_normal.svg');
      position: relative;
      right: -8px;
      display: inline-block;
      vertical-align: top;
      width: 24px;
      height: 24px;
    }
  }
  .is-current>.el-tree-node__content>.el-tree-node__label{
    i {
      content:url('../../assets/icon/btn_main_video_active.svg');
    }
  }
}
.td-share-dialog {
  .share-title {
    margin-top: 12px;
    a {
      text-decoration: none;
      color: inherit;
    }
    span {
      margin-left: 8px;
      vertical-align: middle;
      &:hover {
        color: #008cd6;
        cursor: pointer;
      }
    }
  }
  i.td-icon-mail {
    background-image: url('../../assets/icon/btn_mail.svg');
    background-size: 20px;
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  i.td-icon-confirm {
    background-image: url("../../assets/icon/img_typing check_confirm.svg");
    background-size: 20px;
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    float: right;
  }
  i.td-icon-duplicate {
    background-image: url("../../assets/icon/btn_copy.svg");
    background-size: 20px;
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
}
.tp-downloadallpdf-loading-dialog {
    .el-dialog__title{
      color: #ce2f2f;
    }
    .el-dialog__body {
      padding: 0 20px 20px 20px;
      color: #787878;
      div.context {
        height: 24px;
        line-height: 24px;
        text-align: center;
      }
    }
    .el-dialog__footer {
      padding: 0 20px;
      border-top: solid #c8c8c8 1px;
      .el-button {
        border: none;
        font-size: 16px;
        color: #787878;
        padding: 16px;
        span {
          font-weight: bold;
          font-family: "Roboto Bold", "Microsoft JhengHei";
        }
        &:hover {
          background-color: #ffffff;
        }
      }
    }
}
</style>

<style lang="scss" scoped>
.guidesDoc {
  z-index: 3;
  background-color: white;
  position: relative;
  top: 0;
  transition: top 0.1s ease;
  .doc-nav {
    width: 100%;
    position: sticky;
    top: 0;
    border-bottom: 1px solid #c8c8c8;
    height: 56px;
    line-height: 55px;
    background: #fafafa;
    z-index: 2;
    display: flex;
    justify-content:flex-end;
    box-sizing: border-box;
    .header-left {
      padding-left: 50px;
      text-align: left;
      font-size: 14px;
      color: #787878;
      display: inline-block;
      margin-right:auto;
      .menu-item {
        cursor: default;
        display: inline-block;
        padding-right: 5px;
        line-height: initial;
        text-decoration: none;
        vertical-align: middle;
        div {
          overflow: hidden;
          white-space: nowrap;
          display: flex;
          a {
            font-size: 14px;
            font-weight: normal;
            color: #787878;
            cursor: pointer;
            text-decoration: none;
            border-bottom: solid 1px #787878;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 6px;
            margin-right: 6px;
          }
        }
      }
    }
    .header-right {
      padding-right: 30px;
      text-align: right;
      font-size: 16px;
      color: #008cd6;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .header-right-button {
        text-decoration: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        padding-left: 2px;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 32px;
          background-size: 24px;
        }
        span {
          text-decoration: none;
          padding-left: 4px;
          padding-right: 6px;
          line-height: 32px;
          font-size: 16px;
          color: #008cd6;
        }
        &:hover {
          background-color: #e5f6ff;
        }
        &:active {
          background-color: #008cd6;
          span {
            color: #fff;
          }
        }
      }
      .download {
        .icon-download {
          background-image: url("../../assets/icon/btn_download_blue_normal.svg");
        }
        &:active {
          .icon-download {
            background-image: url("../../assets/icon/btn_download_white_normal.svg");
          }
        }
      }
      .feedback {
        .icon-feedback {
          background-image: url("../../assets/icon/btn_feedback_blue_normal.svg");
        }
        &:active {
          .icon-feedback {
            background-image: url("../../assets/icon/btn_feedback_white_normal.svg");
          }
        }
      }
      .share {
        .icon-share {
          background-image: url("../../assets/icon/btn_share_blue_normal.svg");
        }
        &:active {
          .icon-share {
            background-image: url("../../assets/icon/btn_share_white_normal.svg");
          }
        }
      }
      .mb-closesideMenu {
        display: none;
        .icon-sideMenu {
          background-image: url("../../assets/icon/btn_main_changelog_normal.svg");
          &:active {
            background-image: url("../../assets/icon/btn_main_changelog_active.svg");
          }
        }
      }
    }
  }
  .el-col {
    padding: 0;
    height: 56px;
    line-height: 56px;
  }
  .doc-warning-dialog{
    display: flex;
    position: sticky;
    top: 56px;
    z-index: 2;
    justify-content: space-between;
    padding: 24px 30px 24px 50px;
    border-bottom: 1px solid #c8c8c8;
    border-right: none;
    background-color: #ffecb3;
    div{
      padding-right: 8px;
      span{
        margin-left: 8px;
        line-height: 32px;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
      }
    }
  }
  .mainContent {
    position: relative;
    display: flex;
    background: #fff;
    .mdFile {
      width: 100%;
      flex:1;
    }
    .sideMenuWrap {
      width: 330px;
      box-sizing: border-box;
      .sideMenu {
        padding-top: 18px;
        padding-left: 54px;
        padding-bottom: 30px;
        width: 252px;
        .menuLevl3 {
          line-height: 48px;
          font-size: 16px;
          font-weight: bold;
          font-family: "Roboto Bold", "Microsoft JhengHei";
          color: #004280;
          border-bottom: solid 1px #e6e6e6;
        }
      }
    }
    .closesideMenu {
      flex: none;
      width: 10px;
      cursor: pointer;
      background: #fafafa;
      transition: padding-left 0.2s;
      .drag {
        display: inline-block;
        z-index: 999;
        margin-top: 86px;
        margin-left: 3px;
        height: 21px;
        width: 4px;
        background-size: 4px;
        background-image: url("../../assets/icon/btn_main_split_20_normal.svg");
        &:hover {
          background-image: url("../../assets/icon/btn_main_split_20_hover.svg");
        }
        &:active {
          background-image: url("../../assets/icon/btn_main_split_20_active.svg");
        }
      }
      &:hover {
      background: #e6e6e6;
      }
    }
    .sideMenuClose {
      margin-left: 20px;
    }
  }
  @media (max-width: 1035px) {
    .doc-nav {
      .header-left {
        padding-left: 40px;
      }
    }
    .doc-warning-dialog{
      padding: 16px 30px 16px 40px;
    }
    .mainContent {
      .sideMenuWrap {
        .sideMenu {
          padding-left: 44px;
        }
      }
    }
  }
  @media (max-width: 950px) {
    .doc-nav {
      height: 48px;
      line-height: 47px;
      .header-left {
        padding-left: 20px;
      }
      .header-right {
        padding-right: 0;
        width: 112px;
        .header-right-button {
          margin-right: 8px;
          margin-left: 2px;
          padding-left: 0;
          background-color: #fafafa;
          border-radius: 24px;
          span {
            display: none;
          }
          &:hover {
            background-color: #e5f6ff;
          }
          &:active {
            background-color: #008cd6;
          }
        }
        .download {
          .icon-download {
            background-image: url("../../assets/icon/btn_download_blue_normal.svg");
          }
          &:active {
            .icon-download {
              background-image: url("../../assets/icon/btn_download_white_normal.svg");
            }
          }
        }
        .feedback {
          .icon-feedback {
            background-image: url("../../assets/icon/btn_feedback_blue_normal.svg");
          }
          &:active {
            .icon-feedback {
              background-image: url("../../assets/icon/btn_feedback_white_normal.svg");
            }
          }
        }
      }
    }
    .doc-warning-dialog{
      top: 48px;
      padding: 16px 4px 16px 20px;
    }
    .mainContent {
      .sideMenuWrap {
        top: 48px;
        max-height: calc(100vh - 128px);
        .sideMenu {
          padding-left: 24px;
        }
      }
      .closesideMenu {
        top: 48px;
      }
    }
  }

  @media (max-width: 635px) {
    .doc-nav {
      .header-left {
        padding-left: 20px;
        max-width: calc(100% - 140px);
        overflow: hidden;
        .menu-item {
          width: -webkit-fill-available;
        }
      }
      .header-right {
        .mb-closesideMenu {
          display: flex;
        }
      }
    }
    .mainContent {
      .sideMenuWrap {
        background: #fff;
        width: 100%;
        max-height: none !important;
        .sideMenu {
          padding-left: 34px;
          padding-bottom: 0;
          padding-right: 20px;
          width: initial;
        }
      }
      .closesideMenu {
        display: none;
      }
    }
    .mdFile-mb-hide {
      display: none;
    }
  }
}
.tp-icon-loading {
  height: 32px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../assets/icon/img_loading_1.svg") !important;
  animation: myRotate 1s linear infinite;
}

@keyframes myRotate{
  0%{ -webkit-transform: rotate(0deg);}
  50%{ -webkit-transform: rotate(180deg);}
  100%{ -webkit-transform: rotate(360deg);}
}
</style>
